import { ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import { formatUnits } from "viem";
import type { BridgeTx } from "../../state/types";
import { formatTimestamp } from "../../utils";
import { TxHashLink } from "../TxHashLink";
import { BridgeCard } from "../bridge/BridgeCard";
import { TransactionTypeChip } from "../bridge/TransactionTypeChip";

export function BridgeTxDetails({
  txData,
}: {
  txData: BridgeTx;
}) {
  const displayAmount = formatUnits(txData.amount, txData.tokenDecimals);
  const status = txData.state === "unclaimed" ? "Unclaimed" : "Claimed";

  const ethereumHash =
    txData.bridgeType === "withdraw" ? (
      txData.state === "claimed" ? (
        <TxHashLink txHash={txData.claimTxHash} source="l1" />
      ) : (
        "Unclaimed"
      )
    ) : (
      <TxHashLink txHash={txData.txHash} source="l1" />
    );
  const aztecHash =
    txData.bridgeType === "deposit" ? (
      txData.state === "claimed" ? (
        <TxHashLink txHash={txData.claimTxHash} source="l2" />
      ) : (
        "Unclaimed"
      )
    ) : (
      <TxHashLink txHash={txData.txHash} source="l2" />
    );

  const senderAddressSource = txData.bridgeType === "deposit" ? "l1" : "l2";
  const recipientAddressSource = txData.bridgeType === "deposit" ? "l2" : "l1";

  return (
    <ModalContent>
      <ModalHeader>Bridge details</ModalHeader>
      <ModalBody>
        <BridgeCard
          bridgeType={txData.bridgeType}
          displayAmount={Number(displayAmount)}
          tokenSymbol={txData.tokenSymbol}
        />

        <div className="w-full space-y-3">
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Status</div>
            <div className="font-semibold text-[#36CC36]">{status}</div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Transaction type</div>
            <TransactionTypeChip type="public" />
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Date & Time</div>
            <div className="font-semibold">{formatTimestamp(txData.timestamp)}</div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Ethereum hash</div>
            <div className="font-semibold">{ethereumHash}</div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Aztec hash</div>
            <div className="font-semibold">{aztecHash}</div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">From</div>
            <div className="font-semibold">
              <TxHashLink txHash={txData.senderAddress} source={senderAddressSource} />
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">To</div>
            <div className="font-semibold">
              <TxHashLink txHash={txData.recipientAddress} source={recipientAddressSource} />
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-semibold text-[#ADC0D0]">Network Fee</div>
            <div className="font-semibold">0.00005 ETH</div>
          </div>
        </div>
      </ModalBody>
    </ModalContent>
  );
}
